import React from "react";

/**
 * State labels required by the Mirrorloops brief:
 * LIVE / BETA / EXPERIMENTAL / LABS / ROADMAP / DEMO DATA
 *
 * "Mirrorloops should gain credibility by being unusually clear about what
 * exists and what is being invented."
 */

const STATES = {
  LIVE: {
    label: "LIVE",
    className: "border-emerald-500/40 text-emerald-400",
    dot: "bg-emerald-400",
  },
  BETA: {
    label: "BETA",
    className: "border-[#00E5FF]/40 text-[#00E5FF]",
    dot: "bg-[#00E5FF]",
  },
  EXPERIMENTAL: {
    label: "EXPERIMENTAL",
    className: "border-[#D4B878]/40 text-[#E8D6A3]",
    dot: "bg-[#D4B878]",
  },
  LABS: {
    label: "LABS",
    className: "border-[#CCFF00]/50 text-[#CCFF00]",
    dot: "bg-[#CCFF00]",
  },
  ROADMAP: {
    label: "ROADMAP",
    className: "border-white/20 text-white/50",
    dot: "bg-white/40",
  },
  DEMO: {
    label: "DEMO DATA",
    className: "border-white/20 text-white/50",
    dot: "bg-white/40",
  },
};

export default function StateBadge({ state = "LIVE", size = "md", className = "" }) {
  const s = STATES[state] || STATES.LIVE;
  const px = size === "sm" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`state-badge-${s.label.toLowerCase().replace(/\s/g, "-")}`}
      className={`inline-flex items-center gap-1.5 border uppercase tracking-[0.22em] font-bold ${px} ${s.className} ${className}`}
    >
      <span className={`w-1 h-1 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
